import React, { Component } from 'react';

class ResponsiveFrame extends Component {
    render() {
        const {
            children,
            className = '',
            padding = '20px',
            margin = '20px 0',
            border = '2px solid #e0e0e0',
            borderRadius = '0',
            backgroundColor = '#ffffff',
            boxShadow = '0 4px 8px rgba(0,0,0,0.1)',
            maxWidth = '1200px',
            style = {}
        } = this.props;

        const frameStyle = {
            padding: padding,
            margin: margin,
            border: border,
            borderRadius: borderRadius,
            backgroundColor: backgroundColor,
            boxShadow: boxShadow,
            maxWidth: maxWidth,
            width: '100%',
            boxSizing: 'border-box',
            transition: 'all 0.3s ease',
            ...style
        };

        return (
            <div className={`responsive-frame ${className}`} style={frameStyle}>
                {children}
            </div>
        );
    }
}

export default ResponsiveFrame;